import lodashCompact from 'lodash-es/compact';
import lodashIncludes from 'lodash-es/includes';
import type { RouteMapI18n } from 'vue-router';

import { SellingMethod, AssetType } from '~/apiClient';
import { ROUTE_NAMES, type RouteName, SDP_ROUTE_NAMES, type SdpRouteName, SLP_ROUTE_NAMES, type SlpRouteName } from '~/constants/routes';
import type { PlatformBusClass } from '~/types/asset.type';
import { type PlatformSellingMethod } from '~/types/sale.type';

export type FormatSlpRouteParams = {
    sellingMethod: PlatformSellingMethod;
    assetType: AssetType;
    platformClass?: PlatformBusClass;
    brandUrlKey?: string;
    modelUrlKey?: string;
};

type FormatSlpRouteOptionalParams = (optionalParams: OptionalParams) => string[] | '';

export const formatSlpRouteOptionalParams: FormatSlpRouteOptionalParams = optionalParams => {
    const usefulOrderedParams = lodashCompact(optionalParamsOrder.map(param => optionalParams[param]));
    const paramsMappingSegment = optionalParamsOrder
        .filter(param => optionalParams[param])
        .map(param => optionalParamsLetter[param])
        .join('');

    return usefulOrderedParams.length ? [...usefulOrderedParams, paramsMappingSegment] : '';
};

export const isSlpRoute = (routeName?: keyof RouteMapI18n): routeName is SlpRouteName =>
    !!routeName && lodashIncludes(SLP_ROUTE_NAMES as readonly string[], routeName);

export const isSdpRoute = (routeName?: keyof RouteMapI18n): routeName is SdpRouteName =>
    !!routeName && lodashIncludes(SDP_ROUTE_NAMES as readonly string[], routeName);

export const isNavigatingBetweenSlpRoutes = (toName?: keyof RouteMapI18n, fromName?: keyof RouteMapI18n): boolean =>
    isSlpRoute(toName) && isSlpRoute(fromName);

export const getSellingMethodFromRouteName = (routeName: SlpRouteName): PlatformSellingMethod => {
    switch (routeName) {
        case ROUTE_NAMES.DIRECT_SALE_LISTING:
            return SellingMethod.DirectSale;
        case ROUTE_NAMES.AUCTION_LISTING:
            return SellingMethod.Auction;
    }
};

export const isRouteName = (routeName?: keyof RouteMapI18n): routeName is RouteName =>
    !!routeName && Object.values(ROUTE_NAMES).includes(routeName as RouteName);
